import { ObjectTypes } from '../../shared/enums/objectTypes';

export class ReportTypesRequest {
  employeeId: number;
  objectTypes: ObjectTypes[];
}
